import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    containerCard: {
        width: (props) => props.desktopCardWidth,
        boxShadow: "unset !important",
        border: "1.5px solid #E2E2E2",
        [theme.breakpoints.down("xs")]: {
            width: "100%",
            height: "fit-content",
        },
    },
    root: {
        display: "flex",
        justifyContent: "space-between",
        width: (props) => props.desktopCardWidth,
        height: "141px",
        [theme.breakpoints.down("xs")]: {
            flexDirection: "column",
            width: "100%",
            height: "178px",
        },
    },
    media: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: theme.spacing(2.5, 1.5, 0, 2.5),
        height: "120px",
        width: "50%",
        boxShadow: theme.shadows[5],
        borderRadius: "10px",
        [theme.breakpoints.down("xs")]: {
            flexDirection: "column",
            margin: theme.spacing(0),
            boxShadow: "inset 0 -5px 10px -1px #fff",
            borderRadius: "0px",
            width: "100%",
            height: "79px",
        },
    },
    cardContent: {
        padding: theme.spacing(1),
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "column",
        width: "90%",
        paddingTop: "20px",
        [theme.breakpoints.down("xs")]: {
            padding: theme.spacing(0),
        },
    },
    titleContainer: {
        width: "100%",
        marginBottom: theme.spacing(1),
        [theme.breakpoints.down("xs")]: {
            marginBottom: theme.spacing(0),
        },
    },
    title: {
        padding: theme.spacing(1, 1.5, 1, 1.5),
        fontSize: "16px",
        lineHeight: "20px",
    },
    details: {
        paddingLeft: theme.spacing(1.5),
        paddingRight: theme.spacing(1.2),
        marginBottom: theme.spacing(0.4),
        fontSize: theme.spacing(1.7),
        lineHeight: "17.07px",
    },
    date: {
        fontSize: theme.spacing(1.5),
        lineHeight: "15px",
    },
    actionContainer: {
        marginTop: theme.spacing(2),
        color: theme.palette.success.main,
    },
    loadingImage: {
        height: "inherit",
        width: "100%",
    },
    otherDetailsLoader: {
        width: "100px",
    },
    dateLoader: {
        width: "150px",
        marginTop: "20px",
    },
    buttonLoader: {
        height: "60px",
    },
    titleText: {
        fontSize: "16px",
        fontWeight: 500,
    },
    toolTipText: {
        fontSize: "16px",
        fontWeight: 500,
    },
    dot: {
        height: theme.spacing(1),
        width: theme.spacing(1),
        borderRadius: "50%",
        margin: theme.spacing(0.25),
    },
    success: { background: theme.palette.success.main },
    grey: { background: theme.palette.grey[500] },
}));

export const registeredCardStyles = makeStyles((theme) => ({
    containerCard: {
        width: (props) => props.desktopCardWidth,
        boxShadow: "unset !important",
        border: "1.5px solid #E2E2E2",
        [theme.breakpoints.down("xs")]: {
            width: "100%",
            height: "fit-content",
        },
    },
    root: {
        display: "flex",
        justifyContent: "space-between",
        width: (props) => props.desktopCardWidth,
        height: "141px",
        [theme.breakpoints.down("xs")]: {
            flexDirection: "column",
            width: "100%",
            height: "200px",
        },
    },

    directionIcon: {
        display: "inline-flex",
        height: theme.spacing(2),
        justifyContent: "center",
        alignItems: "center",
        verticalAlign: "middle",
    },
    uniqueIdContainer: {
        position: "relative",
        width: "50%",
        [theme.breakpoints.down("xs")]: { width: "100%" },
    },
    uniqueIdCard: {
        color: theme.palette.common.white,
        fontSize: "12px",
        position: "absolute",
        left: "10px",
        boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.5)",
        bottom: "10px",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: "90%",
        background: theme.palette.primary.main,
        borderBottomLeftRadius: "15px",
        borderBottomRightRadius: "15px",
    },
    mobileUniqueIdCard: {
        color: theme.palette.common.white,
        fontSize: "12px",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        padding: theme.spacing(0, 2),
        background: theme.palette.primary.main,
        borderBottomRightRadius: "15px",
        borderTopRightRadius: "15px",
    },
    media: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: theme.spacing(1.25),
        height: "120px",
        width: "90%",
        boxShadow: theme.shadows[5],
        borderRadius: "10px",
        [theme.breakpoints.down("xs")]: {
            flexDirection: "column",
            margin: theme.spacing(0),
            boxShadow: "inset 0 -5px 10px -1px #fff",
            borderRadius: "0px",
            width: "100%",
            height: "79px",
        },
    },
    loadingCard: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "30%",
    },
    loadingDetails: {
        width: "150px",
    },
    loadingDate: {
        width: "120px",
    },
    cardContent: {
        padding: theme.spacing(1),
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "column",
        width: "90%",
        height: "100px",
        marginTop: "10px",
        [theme.breakpoints.down("xs")]: {
            padding: theme.spacing(0),
        },
    },
    titleContainer: {
        width: "100%",
        marginBottom: theme.spacing(1),
        [theme.breakpoints.down("xs")]: {
            marginBottom: theme.spacing(0),
        },
    },
    title: {
        padding: theme.spacing(1, 1.5, 1, 1.5),
        fontSize: "16px",
        lineHeight: "20px",
    },
    titleOnHover: {
        "&:hover": {
            textDecoration: "underline",
            cursor: "pointer",
        },
    },
    date: {
        width: "100%",
        paddingLeft: theme.spacing(1.5),
        paddingRight: theme.spacing(1.2),
        marginBottom: theme.spacing(0.25),
    },
    otherDetails: {
        paddingLeft: theme.spacing(1.5),
        paddingRight: theme.spacing(1.2),
        marginBottom: theme.spacing(0.4),
    },
    actionContainer: {
        marginTop: theme.spacing(2),
    },
    smallIcon: {
        fontSize: theme.spacing(2),
        color: theme.palette.secondary.main,
    },
    buttonLoader: {
        height: "60px",
    },
    dot: {
        height: theme.spacing(1),
        width: theme.spacing(1),
        borderRadius: "50%",
        margin: theme.spacing(0.25),
    },
    success: { background: theme.palette.success.main },
    grey: { background: theme.palette.grey[500] },
    titleText: {
        fontSize: "16px",
        fontWeight: 500,
    },
    toolTipText: {
        fontSize: "16px",
        fontWeight: 500,
    },
}));
